module.exports = __webpack_public_path__ + "assets/img/active_community_l3-1.f147b6fe.png";